import client from "../client";
import { postContactConfig } from "./postContactConfig";

const postContact = (data?: object) => client({ ...postContactConfig, data: { ...data } });

export default { postContact };
